/**
 * Product Launch Section JavaScript
 * Handles Embla carousel functionality for product media gallery
 */
document.addEventListener('DOMContentLoaded', function () {
  function carouselEventListener(Carousel) {
    Carousel.forEach(function (emblaNode) {
      initializeCarousel(emblaNode);
    });
  }

  function initializeCarousel(emblaNode) {
    const container = emblaNode.querySelector('.embla__container');
    const slides = emblaNode.querySelectorAll('.embla__slide');
    const prevBtn = emblaNode.parentElement.querySelector(
      '.embla__button--prev'
    );
    const nextBtn = emblaNode.parentElement.querySelector(
      '.embla__button--next'
    );
    const dotsContainer = emblaNode.parentElement.querySelector('.embla__dots');

    if (!container || slides.length === 0) return;

    let currentIndex = 0;
    const maxIndex = slides.length - 1;

    // Create dots
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      slides.forEach(function (_, index) {
        const dot = document.createElement('button');
        dot.className = 'embla__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        if (index === 0) dot.classList.add('active');

        dot.addEventListener('click', function () {
          goToSlide(index);
        });

        dotsContainer.appendChild(dot);
      });
    }

    // Update carousel position
    function updateCarousel() {
      const offset = -currentIndex * 100;
      container.style.transform = `translateX(${offset}%)`;

      // Update button states
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex === maxIndex;
      }

      // Update dots
      if (dotsContainer) {
        const dots = dotsContainer.querySelectorAll('.embla__dot');
        dots.forEach(function (dot, index) {
          dot.classList.toggle('active', index === currentIndex);
        });
      }
    }

    // Go to specific slide
    function goToSlide(index) {
      if (index >= 0 && index <= maxIndex) {
        currentIndex = index;
        updateCarousel();
      }
    }

    // Previous slide
    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }

    // Next slide
    function nextSlide() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    }

    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }

    // Touch/swipe support
    let startX = 0;
    let isDragging = false;

    emblaNode.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    emblaNode.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
    });

    emblaNode.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;

      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    });

    // Mouse drag support
    let mouseStartX = 0;
    let isMouseDragging = false;

    emblaNode.addEventListener('mousedown', function (e) {
      mouseStartX = e.clientX;
      isMouseDragging = true;
      emblaNode.style.cursor = 'grabbing';
    });

    emblaNode.addEventListener('mousemove', function (e) {
      if (!isMouseDragging) return;
      e.preventDefault();
    });

    emblaNode.addEventListener('mouseup', function (e) {
      if (!isMouseDragging) return;
      isMouseDragging = false;
      emblaNode.style.cursor = 'grab';

      const endX = e.clientX;
      const diff = mouseStartX - endX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    });

    emblaNode.addEventListener('mouseleave', function () {
      isMouseDragging = false;
      emblaNode.style.cursor = 'grab';
    });

    // Keyboard navigation
    emblaNode.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        nextSlide();
      }
    });

    // Auto-play (optional - can be enabled via section settings)
    let autoPlayInterval;

    function startAutoPlay() {
      if (slides.length > 1) {
        autoPlayInterval = setInterval(function () {
          if (currentIndex === maxIndex) {
            goToSlide(0);
          } else {
            nextSlide();
          }
        }, 5000);
      }
    }

    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    }

    // Initialize
    updateCarousel();

    // Set cursor style
    if (slides.length > 1) {
      emblaNode.style.cursor = 'grab';
      emblaNode.setAttribute('tabindex', '0');
    }
  }

  function init() {
    // Initialize main gallery carousels
    const emblaContainers = document.querySelectorAll(
      '.ecs-product-launch__embla'
    );
    // Initialize mobile floating blocks carousels
    const mobileEmblaContainers = document.querySelectorAll(
      '.ecs-product-launch__mobile-embla'
    );

    carouselEventListener(emblaContainers);
    carouselEventListener(mobileEmblaContainers);
  }

  init();

  // Utility function to debounce resize events
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = function () {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const emblaContainers = document.querySelectorAll(
    '.ecs-product-launch__embla'
  );

  function resetCarousel(Carousel) {
    Carousel.forEach(function (emblaNode) {
      const container = emblaNode.querySelector('.embla__container');
      if (container) {
        // Reset any transformations that might be broken
        const currentTransform = container.style.transform;
        container.style.transform = '';
        setTimeout(function () {
          container.style.transform = currentTransform;
        }, 50);
      }
    });
  }

  // Handle resize events
  window.addEventListener(
    'resize',
    debounce(function () {
      // Re-initialize carousels on resize if needed
      resetCarousel(emblaContainers);
    }, 250)
  );
});
